import {Injectable} from '@angular/core';

import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import {apiEndpoints, CommonConstant, systemValues} from '../../app.constants';
import {Platform} from '../../../models/influencer';
import {BackendHttpService} from '../../core/backend-http.service';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {UserService} from '../user.service';

@Injectable()
export class CommonService extends BackendHttpService<any> {

  constructor(protected router: Router,
              protected translate: TranslateService,
              private userService: UserService) {
    super(router, translate);
  }

  getPlatforms(): Observable<Platform[]> {
    const apiUrl = `${apiEndpoints.getPlatform}`;

    return this.get(apiUrl).map((res: any) => {
        return res.data;
      });
  }

  storeUTMData(utmSource, utmCampaign, utmMedium) {
    if (utmSource) {
      localStorage.setItem('utm_source', utmSource);
    }
    if (utmCampaign) {
      localStorage.setItem('utm_campaign', utmCampaign);
    }
    if (utmMedium) {
      localStorage.setItem('utm_medium', utmMedium);
    }
  }

  clearUTMData() {
    localStorage.removeItem('utm_source');
    localStorage.removeItem('utm_campaign');
    localStorage.removeItem('utm_medium');
  }

  resolvePlatformIconUrl(platformName) {
    // fix the wrong platform name
    if (platformName === 'YouTube') {
      platformName = 'Youtube';
    }
    return `${systemValues.platformIconPath}/${platformName}.svg`;
  }

  public normalizeDataForActivityLineChart(data: any[]): any {
    const activityLineChartData = [];
    const reachColor = this.userService.chartColors[0];
    const impressionColor = this.userService.chartColors[1];
    const engagementColor = this.userService.chartColors[2];
    if (data) {
      const reachLine = {
        name: CommonConstant.REACH_NAME,
        data: [],
        color: reachColor,
        marker: {
          symbol: CommonConstant.CHART_OPTIONS.LEGEND_SYMBOL_TYPE.CIRCLE,
          fillColor: reachColor,
        },
      };
      const impressionsLine = {
        name: CommonConstant.IMPRESSIONS_NAME,
        data: [],
        color: impressionColor,
        marker: {
          symbol: CommonConstant.CHART_OPTIONS.LEGEND_SYMBOL_TYPE.CIRCLE,
          fillColor: impressionColor,
        },
      };
      const engagementLine = {
        name: CommonConstant.ENGAGEMENT_NAME,
        data: [],
        color: engagementColor,
        marker: {
          symbol: CommonConstant.CHART_OPTIONS.LEGEND_SYMBOL_TYPE.CIRCLE,
          fillColor: engagementColor,
        },
      };

      data.forEach(item => {
        const dateKpi = new Date(item.date);
        engagementLine.data.push([dateKpi.getTime(), Math.round(item.engagement)]);
        if (item.impression !== undefined) {
          impressionsLine.data.push([dateKpi.getTime(), Math.round(item.impression)]);
        } else if (item.impressions !== undefined) {
          impressionsLine.data.push([dateKpi.getTime(), Math.round(item.impressions)]);
        }
        reachLine.data.push([dateKpi.getTime(), Math.round(item.reach)]);
      });

      activityLineChartData.splice(0, 0, engagementLine);
      activityLineChartData.splice(0, 0, reachLine);
      activityLineChartData.splice(0, 0, impressionsLine);
      return activityLineChartData;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/common/common.service.ts